import { Colors } from 'library';
import { Card, Row, Stack, Text } from 'library/ui';
import ErrorIcon from '@mui/icons-material/Error';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ShiftProviderUser } from 'models';
import React, { useState } from 'react';
import ComplianceActionInfoModal from './ComplianceActionInfoModal';

export default function ComplianceHoldActions({
    needs_center_action,
    business_location_id,
    refresh,
    provider_user,
}: {
    provider_user: ShiftProviderUser;
    business_location_id: number;
    refresh: () => void;
    needs_center_action: string[];
}) {
    const [modalOpen, setModalOpen] = useState(false);
    const initiateAgencyReviewRequired = needs_center_action.includes('initiate_agency_review');
    const initiateResubmissionRequired = needs_center_action.includes('initiate_resubmission');

    if (!initiateAgencyReviewRequired && !initiateResubmissionRequired) return null;
    const actionText = initiateAgencyReviewRequired ? 'Initiate Agency Review' : 'Complete Resubmission';

    return (
        <>
            <Card tone="error" padding="xs" onClick={() => setModalOpen(true)}>
                <Row justify="between" align="center" fullWidth>
                    <Stack gap="none" align="center">
                        <Text size="xs" weight="bold">
                            <ErrorIcon htmlColor={Colors.error} fontSize="small" />
                            &nbsp;Action Needed:
                        </Text>
                        <Text size="xs">{actionText}</Text>
                    </Stack>
                    <ChevronRightIcon style={{ padding: 0, color: Colors.primary }} />
                </Row>
            </Card>
            <ComplianceActionInfoModal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                actionText={actionText}
                provider_user={provider_user}
                business_location_id={business_location_id}
                refresh={refresh}
            />
        </>
    );
}
